// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fH-z","hovered":"gH-z","hoverImage":"hH-z","mainImage":"iH-z","imageNoBackground":"jH-z","fullSizeImage":"kH-z"};